/**
 * OrganizationsListItem Selectors
 */
import { createSelector } from 'reselect';

import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { selectSeasonsArray } from '../../../../../../services/seasons/selectors';

const selectOrganizationId = (state: AppState, props: any): number => props.organizationId;

const selectOrganizationsSeasons = createSelector(
    [selectSeasonsArray, selectOrganizationId],
    (seasonsArrayState: any, organizationIdState: any) =>
        seasonsArrayState.filter(
            (value: any) => value.organizationId === organizationIdState
        )
);

const makeSelectOrganizationsLatestSeasonId = (): any =>
    createSelector(
        selectOrganizationsSeasons,
        organizationsSeasonsState => {
            if (!organizationsSeasonsState.length) return undefined;
            return organizationsSeasonsState
                .map((value: any) => value.id)
                .reduce((accumulator: any, currentValue: any) =>
                    accumulator < currentValue ? currentValue : accumulator
                );
        }
    );

export { makeSelectOrganizationsLatestSeasonId };
